import { render, staticRenderFns } from "./ExhibitorEditTabAccount.vue?vue&type=template&id=442d2480&"
import script from "./ExhibitorEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ExhibitorEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports